// extracted by mini-css-extract-plugin
module.exports = {"Title":"style_Title__7OEyn","Item":"style_Item__24nyb","Heading":"style_Heading__3wgB7","Text":"style_Text__eGbCL"};